/**
 * Resolve a public asset path against Vite's base URL, so builds work when the
 * game is served from a sub-directory.
 */
export function resolveAsset(path) {
  if (!path) return path;

  if (/^(?:[a-z]+:)?\/\//i.test(path) || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }

  if (path.startsWith('/')) {
    return `${import.meta.env.BASE_URL}${path.slice(1)}`;
  }

  return `${import.meta.env.BASE_URL}${path}`;
}
